import styled from "styled-components";
import { useState, useEffect } from "react";
import PrimaryButton from "../../../../../components/FormControls/PrimaryButton";
import FormCheckBoxWithRightLabel from "../../../../../components/FormControls/FormCheckBoxWithRightLabel";
import request from "../../../../../api/request";
import { NotificationManager } from 'react-notifications';

const StyledFieldProperties = styled.div`
    margin-left: 30px;
`;

const WhiteBoard = styled.div`
    background-color: white;
    width: 750px;
    box-sizing: border-box;
    min-height: 460px;
    padding: 30px;
    margin-bottom: 30px;
    color: ${(props) => props.theme.color.gray};
`;

const Title = styled.span`
    display: block;
    color: ${(props) => props.theme.color.primaryblue};
    font-size: 14px;
    font-weight: 600;
    padding-bottom: 5px;
`;

function FieldProperties(props) {

    const [loadedPage, setLoadedPage] = useState(false);
    const [isSaving, setIsSaving] = useState(false);
    const [voidReasonRequired, setVoidReasonRequired] = useState(false);
    const [reverseReasonRequired, setReverseReasonRequired] = useState(false);

    
    const fetchSettings = async () => {
        try {
            let itemList = [];

            const resp = (await request('database', 'fetchSettings'));
            if (resp.ok) {
                setVoidReasonRequired(resp.data.VoidReasonRequired);
                setReverseReasonRequired(resp.data.ReverseReasonRequired)
            } else {
                console.log(resp.data);
                NotificationManager.error(resp.data);
                return false;
            }
        } catch (e) {
            console.log('Failed to fetch settings: ', e);
            return false;
        }
        return true;
    }

    const onSaveChanges = async () => {
        setIsSaving(true);
        let saveData = {};
        saveData.VoidReasonRequired = voidReasonRequired;
        saveData.ReverseReasonRequired = reverseReasonRequired;

        const resp = (await request('database', 'saveSettings', [saveData]));
        if (resp.ok) {
            NotificationManager.success('Successfully updated field properties');
        } else
        {
            console.log(resp.data);
            NotificationManager.error(resp.data);
        }
        setIsSaving(false);
    }

    useEffect(() => {
        if (!loadedPage) {
            props.setPageTitle('Field properties');
            fetchSettings();
            setLoadedPage(true);
        }
    }, []);

    return (
        <StyledFieldProperties>
            <WhiteBoard>
                <FormCheckBoxWithRightLabel label='Void Reason Required' checked={voidReasonRequired} onCheck={(val) => setVoidReasonRequired(val)}></FormCheckBoxWithRightLabel>
                <FormCheckBoxWithRightLabel label='Reverse Reason Required' checked={reverseReasonRequired} onCheck={(val) => setReverseReasonRequired(val)}></FormCheckBoxWithRightLabel>
            </WhiteBoard>
            <div>
                <PrimaryButton caption={'Save changes'} isLoading={isSaving} onClick={() => onSaveChanges()} style={{width:150, float:'right'}}></PrimaryButton>
            </div>
        </StyledFieldProperties>
    )
}

export default FieldProperties;